<template>
  <form
    autocomplete="off"
    @submit.prevent="submit"
  >
    <slot :loading="loading" />
  </form>
</template>

<script>
import validatorMixin from '../utils/validator'

export default {
  mixins: [validatorMixin],

  props: {
    rules: {
      type: Object,
      required: true
    },

    rulesMessages: {
      type: Object,
      required: false,
      default: () => {}
    },

    customRules: {
      type: Object,
      default: () => ({})
    },

    clearAfterSubmit: {
      type: Boolean,
      default: () => false
    },

    submitOnComplete: {
      type: Boolean,
      default: () => false
    }
  },

  emits: ['on-submit', 'on-submitted', 'on-fail'],

  data: () => ({
    formData: {},
    loading: false
  }),

  computed: {
    // ...mapGetters({
    //   permissions: 'global/getPermissions'
    // })
  },

  watch: {
    // permissions: {
    //   deep: true,
    //   handler() {
    //     this.verifyPermission(true);
    //   },
    // },
  },

  mounted () {
    // this.verifyPermission(true);
    if (this.submitOnComplete) {
      this.listenerForm()
    }

    this.emitter.on('clear-all-inputs', this.clearAllInputs)
  },

  unmounted () {
    this.emitter.off('clear-all-inputs', this.clearAllInputs)
  },

  methods: {
    listenerForm () {
      this.$el.querySelectorAll('input, select, textarea').forEach((input) => {
        input.addEventListener('change', () => {
          this.getFormData()
          const validate = this.validate()
          const validateCustom = this.validateCustomRules()

          if (validate && validateCustom) {
            this.submit()
          }
        })
      })
    },

    /**
     * Submete o formulário, recuperando os dados do mesmo,
     * validando, e se tudo tiver certo chama o on-submit
     * enviando um objeto { data, done, error }.
     */
    submit () {
      // if (!this.verifyPermission()) return;
      if (this.loading) return

      this.loading = true
      this.getFormData()
      this.removeAllInputsErrors()
      const validate = this.validate()
      const validateCustom = this.validateCustomRules()

      if (!validate || !validateCustom) {
        this.loading = false

        return
      }

      this.$emit('on-submit', {
        data: this.formData,
        done: this.onDone,
        fail: this.onFail
      })
    },

    // verifyPermission (onlyTest = false) {
    //   this.loading = Object.keys(this.permissions).length === 0

    //   if (this.$route.meta.isGlobal && onlyTest) {
    //     this.loading = false
    //     return false
    //   }

    //   if (onlyTest) return false

    //   if (this.$route.meta.isGlobal) {
    //     this.loading = false
    //     return true
    //   }

    //   if (!(this.$route.name in this.permissions)) {
    //     this.$bus.$emit('on-toast-show', {
    //       color: 'alert',
    //       message: this.$t('permission-error')
    //     })
    //     return false
    //   }

    //   const permission = this.permissions[this.$route.name]
    //   if (permission !== 'manager') {
    //     this.$bus.$emit('on-toast-show', {
    //       color: 'alert',
    //       message: this.$t('permission-error')
    //     })
    //     return false
    //   }

    //   return true
    // },

    /**
     * Método executado quando a request obtem sucesso, limpa os campos
     * se tiver essa configuração, e emite o evento de sucesso
     */
    onDone (response) {
      if (this.clearAfterSubmit) {
        this.clearAllInputs()
      }

      this.loading = false
      this.$emit('on-submitted', response)
    },

    /**
     * Método executado quando a request falha, verifica o tipo de erro,
     * caso seja um erro global mostra no toast, caso seja um erro de campo,
     * executa ele no campo determinado
     */
    onFail (err) {
      if (err?.message) {
        this.emitter.emit('on-toast-show', {
          color: 'alert',
          message: err.message
        })
      } else if (typeof err === 'string') {
        this.emitter.emit('on-toast-show', {
          color: 'alert',
          message: err
        })
      } else if (typeof err === 'object') {
        Object.keys(err).forEach((field) => {
          if (field in this.formData) {
            const message = Array.isArray(err[field])
              ? err[field][0]
              : err[field]
            this.emitter.emit(`on-${field}-input-error`, message)
          }
        })
      }

      this.loading = false

      this.$emit('on-fail', err)
    },

    /**
     * Valida o formulário de acordo com as regras vindas por propriedade,
     * caso o campo esteja inválido é disparado o evento para ele mostrar o erro
     */
    validate (showErrors = true) {
      const { $validator, formData, rules, rulesMessages } = this
      const errors = $validator(formData, rules, rulesMessages)

      if (Object.keys(errors).length <= 0) return true

      if (showErrors) {
        for (const field in errors) {
          this.emitter.emit(`on-${field}-input-error`, errors[field][0])
        }
      }

      return false
    },

    /**
     * Valida o formulário de acordo com as regras CUSTOMIZADAS vindas por propriedade,
     * caso o campo esteja inválido é disparado o evento para ele mostrar o erro
     */
    validateCustomRules (showErrors = true) {
      let valid = true

      for (const key in this.customRules) {
        const value = this.formData[key]
        const msgOrSuccess = this.customRules[key](value)

        if (msgOrSuccess !== true) {
          if (showErrors) {
            this.emitter.emit(`on-${key}-input-error`, msgOrSuccess)
          }

          valid = false
        }
      }

      return valid
    },

    /**
     * Percorre todos os campos do formulário no HTML, recuperando o valor
     * em um objeto e o setando em this.formData
     */
    getFormData () {
      this.formData = {}
      const formData = new FormData(this.$el)
      const formKeys = formData.keys()
      const formEntries = formData.entries()

      do {
        const field = formEntries.next().value

        if (Array.isArray(field)) {
          const isArray = field[0].includes('[]')
          field[0] = field[0].replace('[]', '')

          if (isArray) {
            if (field[0] in this.formData) {
              this.formData[field[0]].push(field[1])
            } else {
              this.formData[field[0]] = [field[1]]
            }
          } else {
            this.formData[field[0]] = field[1] === '' ? null : field[1]
          }
        }
      } while (!formKeys.next().done)
    },

    /**
     * Percorre todo o formData para emitir o evento de limpar o erro do campo
     */
    removeAllInputsErrors () {
      for (const field in this.formData) {
        this.emitter.emit(`on-${field}-input-error`, '')
      }
    },

    clearAllInputs () {
      if (!this.$el) return

      this.$el.querySelectorAll('input, select, textarea').forEach((input) => {
        if (input.type !== 'hidden') input.value = ''
      })

      this.getFormData()
    }
  }
}
</script>
